<template>
  <div class="cancel-visit">
    <template v-if="mode === 'comment'">
      <form @submit.prevent="onSubmit">
        <standard-input
          type="textarea"
          :rows="5"
          :value="comment"
          @input_change="onInput($event)"
          @input_focus="inputFocus = true"
          @input_blur="inputFocus = false"
          :autofocus="true"
          label="Dlaczego musisz odwołać wizytę?"
        />
        <div>
          <standard-button
            :background-color="primaryColor"
            text-color="white"
            custom-class="cancel-visit-button"
            type="submit"
            :loading="loading"
            text="Potwierdzam odwołanie wizyty"
          />
        </div>
      </form>
    </template>
    <template v-else>
      <p>
        Potwierdzamy, że Twoja wizyta z dnia <strong :style="{ fontWeight: 700 }">
          {{ modalContent.additional.visit.date }}
        </strong>
        <span :style="{ color: thirdColor, fontWeight: 700 }">
          została odwołana.
        </span>
      </p>
      <car-block
        :car="car"
        class="visit-canceled"
        mode="visit"
      />
    </template>
  </div>
</template>

<script>
import StandardButton from '~/StandardButton';
import StandardInput from '~/StandardInput';
import CarBlock from '~/CarBlock';
import { mapGetters, mapActions } from 'vuex';
import ajax from '@/helpers/ajax';
import config from '@/config';

export default {
  components: {
    StandardButton,
    StandardInput,
    CarBlock,
  },
  data() {
    return {
      comment: '',
      mode: 'comment',
      loading: false,
      inputFocus: false,
    };
  },
  computed: {
    ...mapGetters({
      primaryColor: 'brand/getPrimaryColor',
      thirdColor: 'brand/getThirdColor',
      modalContent: 'modal/getContent',
      cars: 'myCars/getMyCars',
    }),
    car() {
      // eslint-disable-next-line
      return this.cars.find(car => car.id == this.modalContent.additional.visit.carID);
    },
  },
  methods: {
    ...mapActions({
      closeModal: 'modal/closeModal',
      getMyCars: 'myCars/fetchMyCars',
    }),
    onInput(value) {
      this.comment = value;
    },
    onSubmit() {
      this.loading = true;

      const data = {
        visit: this.modalContent.additional.visit.id,
        comment: this.comment,
      };

      ajax.post(config.apiEndpoints.cancelVisit, data)
        .then((res) => {
          if (res.status === 200) {
            this.mode = 'confirmed';
            this.getMyCars();
          }
          this.loading = false;
        })
        .catch((error) => {
          console.error(error);
          this.loading = false;
        });
    },
    handleKeyDown(event) {
      const { keyCode } = event;

      if (!this.inputFocus) {
        if (keyCode === 13) {
          this.onSubmit();
        }
      }
    },
  },
  mounted() {
    document.addEventListener('keydown', this.handleKeyDown, false);
  },
  destroyed() {
    document.removeEventListener('keydown', this.handleKeyDown);
  },
};
</script>
